import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import './style/index.less';
import {url,imageurl,formatime,imgurl,isWeiXin,islogin,datatoFile,orderstatus,userlevel,add0,getRouter,getOrderBtn,getDetailBtn,sharePopup} from './utils/location.js';
import {getAjax} from './utils/getAjax.js';
import {cityjson,areajson} from './utils/city.js';
import {field} from './utils/fieldList.js';
import {fshare} from './utils/share.js';
import './utils/funrem.js';
import VuewechatTitle from 'vue-wechat-title'
import Bus from './utils/bus';
import Bscroll from 'better-scroll';
import lrz from 'lrz';
import waterfall from 'vue-waterfall2';
import {VueJsonp} from 'vue-jsonp';
// import 'lib-flexible/flexible';
import Router from 'vue-router';
axios.defaults.withCredentials=true;
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.prototype.ajaxUrl = url; //地址转换
Vue.prototype.axios=axios; //地址转换
Vue.prototype.imageurl=imageurl;//图片集合转换
Vue.prototype.$formatime=formatime;//时间转换
Vue.prototype.$add0=add0;//时间转换
Vue.prototype.$imgurl=imgurl;//图片单个转换
Vue.prototype.$userlevel=userlevel;//城市2联动
Vue.prototype.cityjson=cityjson;//城市2联动
Vue.prototype.areajson=areajson;//城市3联动
Vue.prototype.$getAjax=getAjax;
Vue.prototype.$getRouter=getRouter;
Vue.prototype.$bus=Bus;
Vue.prototype.$share=fshare;//分享
Vue.prototype.isWeiXin=isWeiXin;//是否微信端
Vue.prototype.$islogin=islogin;//弹出登录
Vue.prototype.datatoFile=datatoFile;//图片上传的转换
Vue.prototype.orderstatus=orderstatus;//订单状态
Vue.prototype.$fieldList=field;//表单元素
Vue.prototype.$getOrderBtn=getOrderBtn;//物流列表按钮
Vue.prototype.$getDetailBtn=getDetailBtn;//物流详情按钮
// Vue.prototype.$sharePopup=sharePopup;//分享状态
Vue.use(VueJsonp);
Vue.use(VuewechatTitle);
Vue.use(waterfall)
// Vue.use(vueSwiper)
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");